import { useEffect, useState } from 'react';

import Alert from 'react-bootstrap/Alert';
import AppContainer from '../../../../commons/containers/AppContainer';
import AppInput from '../../../../commons/inputs/AppInput';
import AppLinkButton from '../../../../commons/buttons/AppLinkButton';
import AppLoading from '../../../../commons/AppLoading';
import { Form } from 'react-bootstrap';
import HallAppToast from '../../../../commons/HallAppToast';
import HallPointsAPI from '../../HallPointsAPI';

const hallPointsAPI = new HallPointsAPI();
/* eslint-disable react-hooks/exhaustive-deps */
function HPStep1({ nextStep, configToEdit }) {

    const [selectedServices, setSelectedServices] = useState([]);
    const [services, setServices] = useState([]);
    const [isLoading, setIsloading] = useState(true);
    const [name, setName] = useState(null);

    const toggleService = (service) => {
        const exists = selectedServices.find((s) => s.id === service.id);
        if (exists) {
            setSelectedServices((prev) => prev.filter((s) => s.id !== service.id));
        } else {
            setSelectedServices((prev) => [...prev, { id: service.id, name: service.name }]);
        }
    };

    useEffect(() => {
        findAllServices()
    }, []);


    const findAllServices = async () => {
        try {
            const resp = await hallPointsAPI.fidnAllServices()
            setServices(resp.data)
            populateInfosIfEdit(resp.data)
        } catch (_) {
            HallAppToast.genericError()
            setServices([])
            setIsloading(false)
        } finally {
            setIsloading(false)
        }
    }

    const populateInfosIfEdit = (dataServs) => {
        if (configToEdit != null && Object.keys(configToEdit).length > 0) {
            setName(configToEdit.name)
            configToEdit.services.forEach((servEdit) => {
                const serviceFound = dataServs.find(s => s.id === servEdit.id);
                if (serviceFound) {
                    setSelectedServices((prev) => [...prev, { id: serviceFound.id, name: serviceFound.name }]);
                }
            })
        }
    }

    const allSelected = selectedServices.length === services.length;

    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedServices([]);
        } else {
            setSelectedServices(services.map(({ id, name }) => ({ id, name })));
        }
    };

    const toNext = () => {
        const data = {
            services: selectedServices,
            name: name
        }
        nextStep(data)
    };


    return (
        <div className="container">
            <h5>Escolha os serviços para configurar a pontuação</h5>
            <p>Selecione um ou mais serviços que participarão desta regra de pontos.</p>
            <Alert key={'warning'} variant={'warning'}>
                <p>
                    ⚠️ As configurações definidas nos próximos passos serão aplicadas a todos os serviços selecionados.
                    <br></br> <br></br>Se quiser regras diferentes para serviços diferentes, será necessário criar configurações separadas.
                </p>
            </Alert>

            <Form>
                <label>Escolha um nome para essa regra?</label>
                <AppInput
                    isRequired
                    label="Nome"
                    name="name"
                    errors={[]}
                    value={name}
                    onChange={(e) => { setName(e.target.value) }} />
            </Form>

            {
                isLoading ? <AppLoading /> : <div className="mb-4">
                    <h5 className="mb-3">Selecione os serviços:</h5>
                    <Alert key={'warning'} variant={'warning'}>
                        <p>
                            ⚠️ Alguns serviços (em vermelho) já estão configurados.
                            <br></br>Se selecionar, suas configurações serão atualizadas com as novas regras!
                        </p>
                    </Alert>
                    {/* Checkbox para selecionar todos */}
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="select-all"
                            checked={allSelected}
                            onChange={toggleSelectAll}
                        />
                        <label className="form-check-label fw-bold" htmlFor="select-all">
                            Selecionar todos os serviços <span style={{ color: 'red' }}>*(obrigatório)</span>
                        </label>
                        <hr></hr>
                    </div>

                    {/* Lista de serviços */}
                    {services.map((service) => (
                        <>
                            <div className="form-check" key={service.id}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`service-${service.id}`}
                                    checked={selectedServices.some((s) => s.id === service.id)}
                                    onChange={() => toggleService(service)}
                                />
                                <label className="form-check-label" htmlFor={`service-${service.id}`}>
                                    <span style={{ color: service.hasParametrized && 'red' }}>{service.name} <small className="text-muted">({service.categoryName})</small></span>
                                </label>

                            </div>
                            <p style={{ color: 'red' }}>{service.hasParametrized && 'Já possui configuração'}</p>

                        </>
                    ))}

                    <p style={{ marginBottom: '180px' }}></p>
                </div>
            }

            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '0rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}
            >
                <AppContainer>
                    <AppLinkButton name="Próximo" fullWidth={true} onClick={toNext} disabled={selectedServices.length === 0 || name === null} />
                </AppContainer>
            </div>
        </div>
    );
}

export default HPStep1;